import { render, staticRenderFns } from "./wsymptomchecker.vue?vue&type=template&id=23249a27"
import script from "./wsymptomchecker.vue?vue&type=script&lang=js"
export * from "./wsymptomchecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports